import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useCookies} from "react-cookie";

export default function useIsLatestCookiePolicyAccepted(): boolean {
    const {cookieVersion} = useAppSelector((state) => state.cookies)
    const [cookies, setCookie, removeCookie] = useCookies();
    const consentVersion = cookies.cookiesConsent

    return cookieVersion === consentVersion
}